<template>
	<section class="content-width">
		<notice href="/skills">
			Already know you need a developer, but looking for a specific skill? Check out the Skills page!
		</notice>

		<h2>Services</h2>

		<h3>Websites</h3>
		<p>
			You need a website. Big or small, I build them! I use the latest technologies to ensure that your visitors
			have a pleasant and modern experience on your site. I've built everything from small landing pages to
			enormous CMS driven content libraries.
		</p>

		<h3>Augmented &amp; Virtual Reality</h3>
		<p>
			The future is here! Lots of exciting groundbreaking work is happening in this area, and I'm excited to be a
			part of it. I've built cross-platform web-based VR and AR experiences that don't require the user to
			download anything at all; they simply visit your page and dive into another world! For more powerful
			experiences, I have plenty of experience working with Apple's ARKit technology on iOS devices.
		</p>

		<h3>Mobile Apps</h3>
		<p>
			I can develop apps for both major platforms: Android and iOS. Although sadly the app boom of the early years
			is past us, mobile apps can still provide tremendous value for your business. Often, a mobile app is
			necessary to provide the best experience for your end user or work around the limits of a mobile site. In
			today's age of app exhaustion, app development requires a much more strategic approach. Having built several
			apps, and sometimes even advising against them, I can provide both strategy and development around your
			goals!
		</p>

		<h3>Photo &amp; Video</h3>
		<p>
			I've been working with media for years and offer photography &amp; videography services. I work
			together with <a href="http://www.nalivaykophotography.com">Nalivayko Photography</a>, so feel free to check
			out their work or even contact them directly.
		</p>

		<h3>Software &amp; Computer Maintenance</h3>
		<p>
			Because I've worked with so many different systems, I can help you fix, maintain, and upgrade your existing
			software and hardware systems. Check out some of my <router-link to="/skills">skills</router-link> or
			<a href="mailto:hello@andreyrd.com">get in touch</a> with me to discuss your needs.
		</p>
	</section>
</template>

<script>
import Notice from '@/components/Notice.vue';

export default {
	components: { Notice },
};
</script>

<style>

</style>